//import React, { useEffect, useState } from "react";
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import parse, { domToReact } from "html-react-parser";
import $ from "jquery";
import LoaderOverlay from "../components/LoaderOverlay";
import { Modal } from 'bootstrap';
import { Link } from "react-router-dom";
import "./LoginModal.css";

function Home() {

    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
    const [isLoginAuth, setisLoginAuth] = useState(false);

    const handleLogin = (loginData) => {
        console.log('User logged in:', loginData);
        // Handle login logic here (API call, context update, etc.)
    };

    const options = {
        replace: (domNode) => {
            if (domNode.name === "ul") {
                return (
                    <ul className="list hrs">
                        {domToReact(domNode.children, options)}
                    </ul>
                );
            }
        },
    }

    const [imgPath, setImgPath] = useState([]);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadings, setLoadings] = useState(true);
    const [error, setError] = useState(null);

    const [serviceType, setServiceType] = useState([]);
    const [businessDomains, setBusinessDomains] = useState([]);
    const [projectTypes, setProjectTypes] = useState([]);
    const [client, setClient] = useState([]);

    const [lightB, setlightB] = useState(false);

    // 🔹 API call function https://test.onwork.co.in src =" public/rr/images/
    const fetchData = async (type) => {
        try {
            const response = await axios.post("https://test.onwork.co.in/mis/api/getApiPortfolio", { 'type': type });
            const newData = response.data.collection || [];
            setImgPath(response.data.img_path);
            if (type === 1) {
                setData(newData);
            } else {
                setData((prev) => [...prev, ...newData]);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
            setLoadings(false);
        }
    };


    // 🔹 API call function
    const fetchMaster = async () => {
        const response = await axios.get("https://test.onwork.co.in/mis/api/getApiPortfolioMaster");
        const newData = response.data.collection || [];
        setImgPath(response.data.img_path);
        setServiceType(response.data.serviceType);
        setBusinessDomains(response.data.businessDomains);
        setProjectTypes(response.data.projectTypes);
        setClient(response.data.client);
    };


    const getAuthCheck = async () => {
        const tokens = localStorage.getItem("token");
        try {
            const response = await axios.get(
                "https://test.onwork.co.in/mis/api/validateToken",
                {
                    headers: {
                        Authorization: `Bearer ${tokens}`
                    }
                }
            );
            if (response.data.status) {
                setisLoginAuth(true);
            }
        } catch (error) {
            //console.log("Auth Error:", error.response?.data || error);
        }
    };

    const logOutAuth = async () => {
        setisLoginAuth(false);
        localStorage.removeItem("token");
        window.location.reload();
    };

    // 🔹 First load
    useEffect(() => {
        getAuthCheck();
        fetchData(1);
        setTimeout(() => {
            fetchData(2);
        }, 600);
        fetchMaster();
    }, []);

    function closeModal() {
        const modal = document.getElementById("exampleModalLogin");

        modal.classList.remove("show");     // Remove .show class
        modal.style.display = "none";       // Hide modal
        modal.setAttribute("aria-hidden", "true");
    }

    // Click outside to close
    window.onclick = function (event) {
        const modal = document.getElementById("exampleModalLogin");

        if (event.target === modal) {
            closeModal();
        }
    };

    useEffect(() => {
        if (data.length === 0) return;

        const thumbs = document.querySelectorAll(".thumb");
        const overlay = document.getElementById("lightbox");
        const dataBox = document.getElementById("lightbox-data");
        const closeBtn = document.getElementById("lightbox-close");
        const carouselInner = document.getElementById("carousel-inner");
        const carouselIndicators = document.getElementById("carousel-indicators");
        const items = document.querySelectorAll("#lightbox-items .lightbox-item");
        const nextBtn = document.getElementById("popup-next");
        const prevBtn = document.getElementById("popup-prev");

        if (!overlay || !closeBtn || !nextBtn || !prevBtn) return;

        let currentIndex = 0;

// -------------------------------------------------
        // Fullscreen Helpers
        // -------------------------------------------------
        function openFullscreen(elem) {
            if (!document.fullscreenElement) {
                elem.requestFullscreen?.().catch(() => { });
            }
        }

        function closeFullscreen() {
            if (document.fullscreenElement) {
                document.exitFullscreen?.().catch(() => { });
            }
        }

        // -------------------------------------------------
        // Open Lightbox
        // -------------------------------------------------


        function openModal() {
            const modal = document.getElementById("exampleModalLogin");

            modal.classList.add("show");        // Add .show class
            modal.style.display = "block";      // Show modal
            modal.removeAttribute("aria-hidden");
        }

        function openLightbox(index) {
            setlightB(true);
            window.history.pushState({ lightbox: true }, "", window.location.href);
            if (isLoginAuth == false) {
                openModal();
                return true;
            } else {
                closeModal();
            }

            const item = items[index];
            if (!item) return;

            openFullscreen(overlay);

            // Push state for Back button
            ///window.history.pushState({ lightbox: true }, "");

            const imgs = item.querySelectorAll(".images img");
            carouselInner.innerHTML = "";
            carouselIndicators.innerHTML = "";

            imgs.forEach((img, i) => {
                const active = i === 0 ? "active" : "";
                carouselIndicators.innerHTML += `
                    <button type="button" data-bs-slide-to="${i}" class="${active}"></button>
                `;
                carouselInner.innerHTML += `
                    <div class="carousel-item ${active}">
                        <img src="${img.src}" class="d-block w-100">
                    </div>
                `;
            });

            dataBox.innerHTML = item.querySelector(".content").innerHTML;

            prevBtn.style.visibility = index === 0 ? "hidden" : "visible";
            nextBtn.style.visibility = index === items.length - 1 ? "hidden" : "visible";

            overlay.style.display = "flex";
            setTimeout(() => overlay.classList.add("show"), 10);
        }

        // -------------------------------------------------
        // Close Lightbox
        // -------------------------------------------------
        function closeLightbox() {
            closeFullscreen();

            overlay.classList.remove("show");
            setTimeout(() => (overlay.style.display = "none"), 300);
            setlightB(false);
        }

        // -------------------------------------------------
        // Change Slide
        // -------------------------------------------------
        function changePopupItem() {
            const content = document.querySelector(".lightbox-content");
            content.style.opacity = 0;

            setTimeout(() => {
                openLightbox(currentIndex);
                content.style.opacity = 1;
            }, 200);
        }

        // -------------------------------------------------
        // Thumbnail Click
        // -------------------------------------------------

        thumbs.forEach((thumb) => {
            thumb.addEventListener("click", () => {
                currentIndex = parseInt(thumb.dataset.index);
                openLightbox(currentIndex);
            });
        });

        closeBtn.addEventListener("click", closeLightbox);

        nextBtn.addEventListener("click", () => {
            if (currentIndex < items.length - 1) {
                currentIndex++;
                changePopupItem();
            }
        });

        prevBtn.addEventListener("click", () => {
            if (currentIndex > 0) {
                currentIndex--;
                changePopupItem();
            }
        });

        // -------------------------------------------------
        // Keyboard Controls
        // -------------------------------------------------
        function handleKeyPress(e) {
            if (overlay.style.display !== "flex") return;

            if (e.key === "ArrowRight") {
                if (currentIndex < items.length - 1) {
                    currentIndex++;
                    changePopupItem();
                }
            }

            if (e.key === "ArrowLeft") {
                if (currentIndex > 0) {
                    currentIndex--;
                    changePopupItem();
                }
            }
            // setlightB(false);   e.preventDefault();
            if (e.key === "Escape") {
                closeLightbox();
                setlightB(false);
            }
            // F11 → close fullscreen + close popup
            if (e.key === "F11") {
                closeLightbox();
                setlightB(false);
            }
        }

        function onFullscreenChange() {
            // If fullscreen exited, close popup automatically
            if (!document.fullscreenElement) {
                closeLightbox();
                //window.history.back();
                setlightB(false);
            }
        }

        document.addEventListener("keydown", handleKeyPress);
        document.addEventListener("fullscreenchange", onFullscreenChange);

        // -------------------------------------------------
        // Browser Back Button Handling
        // -------------------------------------------------
        function handleBackButton(e) {
            const isOpen = overlay.style.display === "flex";

            if (isOpen) {
                e.preventDefault();
                closeLightbox();
                setlightB(false);
            }
        }

        window.addEventListener("popstate", handleBackButton);

        // -----------------------------------------
        // MOUSE DRAG & TOUCH SWIPE
        // -----------------------------------------
        let startX = 0;
        let isDown = false;

        function dragStart(x) {
            isDown = true;
            startX = x;
        }

        function dragEnd(x) {
            if (!isDown) return;
            const diff = x - startX;
            const threshold = 50; // swipe strength

            if (Math.abs(diff) > threshold) {
                if (diff < 0) {
                    // drag left → next slide
                    if (currentIndex < items.length - 1) {
                        currentIndex++;
                        changePopupItem();
                    }
                } else {
                    // drag right → previous slide
                    if (currentIndex > 0) {
                        currentIndex--;
                        changePopupItem();
                    }
                }
            }

            isDown = false;
        }

        // Mouse Events
        overlay.addEventListener("mousedown", (e) => dragStart(e.clientX));
        overlay.addEventListener("mouseup", (e) => dragEnd(e.clientX));
        overlay.addEventListener("mouseleave", () => { isDown = false });

        // Touch Events
        overlay.addEventListener("touchstart", (e) => dragStart(e.touches[0].clientX));
        overlay.addEventListener("touchend", (e) => dragEnd(e.changedTouches[0].clientX));



        // -------------------------------------------------
        // Cleanup
        // -------------------------------------------------
        return () => {
            document.removeEventListener("keydown", handleKeyPress);
            window.removeEventListener("popstate", handleBackButton);
        };

    }, [data]);


    const openModal2 = async (id) => {
        const modal = document.getElementById("exampleModalLogin");

        modal.classList.add("show");        // Add .show class
        modal.style.display = "block";      // Show modal
        modal.removeAttribute("aria-hidden");
    }


    const categoryChoose = async (id) => {
        try {
            $("#search_keyword").val('');
            $(".active-cls-001").removeClass('active');
            $(".active-cls-" + id).addClass('active');
            setLoadings(true);
            const response = await axios.post("https://test.onwork.co.in/mis/api/getApiPortfolio", { 'business_domains': id, type: 1 });
            const newData = response.data.collection || [];
            setData(newData);
            $('.service-type-checkbox').prop('checked', false);
            $('.bussiness-domain-checkbox').prop('checked', false);
            $('.project-type-checkbox').prop('checked', false);
            setLoadings(false);
            const responseSecond = await axios.post("https://test.onwork.co.in/mis/api/getApiPortfolio", { 'business_domains': id, type: 2 });
            const newDataSecond = responseSecond.data.collection || [];
            setData((prev) => [...prev, ...newDataSecond]);
        } catch (error) {
            console.error(error);
        };
    };

    const getCheckedIds = async () => {
        $("#search_keyword").val('');
        const checkedServiceType = Array.from(document.querySelectorAll('.service-type-checkbox:checked'))
            .map(el => el.value);

        const checkedDomain = Array.from(document.querySelectorAll('.bussiness-domain-checkbox:checked'))
            .map(el => el.value);

        const checkedProject = Array.from(document.querySelectorAll('.project-type-checkbox:checked'))
            .map(el => el.value);

        const service_types = checkedServiceType.join(',');
        const business_domains = checkedDomain.join(',');
        const project_type = checkedProject.join(',');

        setLoadings(true);
        //setLoading(true);
        const response = await axios.post("https://test.onwork.co.in/mis/api/getApiPortfolio", {
            'business_domains': business_domains,
            'project_type': project_type,
            'service_types': service_types
        });
        const newData = response.data.collection || [];
        setData(newData);
        $(".active-cls-001").removeClass('active');
        $(".active-cls-0").addClass('active');
        setLoadings(false);
        //setLoading(false); 
        $(".getCheckedIds").trigger('click');
    };


    const getSearchByProject = async () => {
        $('.service-type-checkbox').prop('checked', false);
        $('.bussiness-domain-checkbox').prop('checked', false);
        $('.project-type-checkbox').prop('checked', false);
        $(".active-cls-001").removeClass('active');
        $(".active-cls-0").addClass('active');
        const searchKeyword = $("#search_keyword").val();
        // setLoading(true);
        setLoadings(true);
        const response = await axios.post("https://test.onwork.co.in/mis/api/getApiPortfolio", { 'search': searchKeyword });
        const newData = response.data.collection || [];
        setData(newData);
        //setLoading(false);
        setLoadings(false);
    };


    useEffect(() => {

        const modalEl = document.getElementById("companyModal");
        if (!modalEl) return;

        let initialized = false;

        modalEl.addEventListener("shown.bs.modal", () => {
            if (!initialized) {
                initSlider();
                initialized = true;
            }
        });

        function initSlider() {
            const container = modalEl.querySelector("#companySlider");
            if (!container) return;

            const slides = container.querySelectorAll(".slide");
            let current = 0;
            const total = slides.length;

            slides.forEach((slide, i) => {
                slide.querySelector(".slide-number").textContent = `${i + 1} / ${total}`;
            });

            const prevBtn = document.createElement("button");
            prevBtn.className = "arrow prev";
            prevBtn.innerHTML = "<span class='material-symbols-outlined'>arrow_back_ios</span>";

            const nextBtn = document.createElement("button");
            nextBtn.className = "arrow next";
            nextBtn.innerHTML = "<span class='material-symbols-outlined'>arrow_forward_ios</span>";

            container.appendChild(prevBtn);
            container.appendChild(nextBtn);

            function changeSlide(dir) {
                slides[current].classList.remove("active");
                current = (current + dir + total) % total;
                slides[current].classList.add("active");
            }

            prevBtn.addEventListener("click", () => changeSlide(-1));
            nextBtn.addEventListener("click", () => changeSlide(1));

            // drag/swipe
            let startX = 0;
            let isDown = false;

            const startDrag = (x) => { isDown = true; startX = x; };
            const endDrag = (x) => {
                if (!isDown) return;
                const diff = x - startX;

                if (Math.abs(diff) > 50) {
                    diff < 0 ? changeSlide(1) : changeSlide(-1);
                }
                isDown = false;
            };

            container.addEventListener("mousedown", (e) => startDrag(e.clientX));
            container.addEventListener("mouseup", (e) => endDrag(e.clientX));
            container.addEventListener("mouseleave", () => (isDown = false));

            container.addEventListener("touchstart", (e) => startDrag(e.touches[0].clientX));
            container.addEventListener("touchend", (e) => endDrag(e.changedTouches[0].clientX));

        }

    }, []);

    const [formData, setFormData] = useState({
        login_id: '',
        password: '',
        rememberMe: false
    });
    const [showPassword, setShowPassword] = useState(false);
    const [errors, setErrors] = useState({});
    const modalRef = useRef(null);


    // Handle input changes
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));

        // Clear error when user starts typing  //handleSubmit
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    // Validate form
    const validateForm = () => {
        const newErrors = {};

        var login_id = $("#login_id").val();
        if (!login_id) {
            newErrors.login_id = 'Login id is required';
        } else if (login_id.length < 3) {
            newErrors.login_id = 'Provide valid login id';
        }
        var password = $("#password").val();
        if (!password) {
            newErrors.password = 'Password is required';
        } else if (password.length < 4) {
            newErrors.password = 'Password must be at least 6 characters';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        setFormData(prev => ({
            ...prev,
            ['login_id']: $('#login_id').val()
        }));
        setFormData(prev => ({
            ...prev,
            ['password']: $('#password').val()
        }));

        if (validateForm()) {
            // In a real app, you would make an API call here
            //console.log('Login data:', formData);
            setLoadings(true);
            const form = e.target;
            const fds = new FormData(form);
            fds.append("EmpID", $('#login_id').val());
            fds.append("password", $('#password').val());
            try {
                const res = await axios.post("https://test.onwork.co.in/mis/api/login", fds);
                if (res.data.status) {
                    $('.d-none-remove').removeClass('d-none');
                    $('.d-none-remove').removeClass('alert-danger');
                    $('.d-none-remove').addClass('alert-success');
                    $('.d-none-remove').html(res.data.message);
                    localStorage.setItem("token", res.data.token); //": "471|TRVeeqB1x3jAxnEY8RCvsKJNMni7XVat7SoTu5tI"
                    setisLoginAuth(true);
                    // setTimeout(() => {

                    // }, 120); 
                    //closeModal();
                    window.location.reload();
                } else {
                    $('.d-none-remove').removeClass('d-none');
                    $('.d-none-remove').html(res.data.message);
                }
            }
            catch (error) {
                // Yaha 401, 400, 500 sab aayenge
                if (error.response) {
                    $('.d-none-remove').removeClass('d-none')
                        .html(error.response.data.message || "Login Failed");
                } else {
                    $('.d-none-remove').removeClass('d-none').html("Network Error");
                }
                setLoadings(false);
            }
            setLoadings(false);
            //onClose();
        }
    };

    // Handle social login
    const handleSocialLogin = (provider) => {
        console.log(`Logging in with ${provider}`);
        // In a real app, you would implement OAuth flow here
        alert(`Redirecting to ${provider} login...`);
    };

    // Handle forgot password
    const handleForgotPassword = () => {
        return true;
        if (!formData.login_id) {
            setErrors(prev => ({ ...prev, login_id: 'Please enter your login_id to reset password' }));
            return;
        }

        console.log('Password reset requested for:', formData.login_id);
        alert(`Password reset link sent to ${formData.login_id}`);
    };

    // Handle register redirect
    const handleRegister = () => {
        console.log('Redirecting to registration...');
        ///onClose(); // Close modal first
        // In a real app, you would navigate to registration page
        alert('Redirecting to registration page...');
    };

    return (
        <>
            <LoaderOverlay loading={loadings} message="Please wait..." />
            <section className="container" id="controls">
                <div className="filter-bar">
                    <div className="row gy-3 align-items-center">
                        <div className="col-md-5">
                            <label className="form-label small">Search Projects</label>
                            <div className="input-group">

                               
                                <input id="search_keyword" name="search_keyword" type="search" className="form-control" placeholder="Search by title, description or tags"   onKeyDown={(e) => {
    if (e.key === 'Enter') {
      getSearchByProject();
    }
  }}/>

                                <button id="reset" className="btn btn-primary" onClick={getSearchByProject} title="Reset">
                                    <i className="fa-solid fa-search"></i>
                                </button>
						        <button id="reset" className="btn btn-danger" onClick={(e) => categoryChoose(0)} title="Reset">
									<i className="fa-solid fa-rotate"></i>
                                </button>
								

                            </div>
                        </div>
                        <div className="col-md-2"></div>
                        <div className="col-md-5">
                            <label className="form-label small" style={{ 'padding-left': '24px' }}>Category</label>
                            <div className="d-flex gap-2 flex-wrap justify-content-end">

                                <button
                                    className="btn btn-outline-danger btn-sm active cat active-cls-001 active-cls-0"
                                    data-cat="All" onClick={(e) => categoryChoose(0)}>All</button>

                                {businessDomains.map((itemDomian, i) => (
                                    <button
                                        className={`btn btn-outline-danger btn-sm cat active-cls-001 active-cls-${itemDomian.value}`}
                                        data-cat={itemDomian.label} onClick={(e) => categoryChoose(itemDomian.value)}>{itemDomian.label}</button>
                                ))}

                                <button type="button"
                                    className="btn btn-primary btn-sm cat"
                                    data-bs-toggle="modal" data-bs-target="#exampleModal">

                                    <i className="fa-solid fa-filter"></i> &nbsp;Sort By
                                </button>

                            </div>
                        </div>
                        <div className="col-md-12 login-logout">

                            {isLoginAuth == false ? <span class="badge badge-success" onClick={(e) => openModal2()}>Login</span> : <span class="badge badge-secondary" onClick={(e) => logOutAuth()}>Logout</span>}

                        </div>
                    </div>
                </div>
            </section>


            {loading ? (
                <section style={{ minHeight: "300px", position: "relative" }}>
                    <div
                        className="d-flex justify-content-center align-items-center"
                        style={{
                            position: "absolute",
                            inset: 0,
                            background: "rgba(255,255,255,0.8)",
                            zIndex: 10,
                        }}
                    >
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </section>
            ) : (
                <section className="mb-6">
                    <div className="container">
                        <ul className="project-list">

                            {data.map((item, i) => (
                                <li>
                                    <div className="project-card p-0 thumb" data-index={i}>
                                        <div className="thumb-image">
                                            <img src={`${imgPath}/${item.project_image}`} alt="Information &amp; Public Relations Portal" className="project-thumb" />
                                        </div>
                                        <div className="title">
                                            <h5 className="mb-1">{item.ClientName}</h5>
                                            <div className="d-flex gap-2 align-items-center category">
                                                <div className="d-flex gap-1 flex-wrap" style={{ 'flex': '1' }}>
                                                    <span className="tag">{item.businessDomains}</span>
                                                </div>
                                                <div>
                                                    <button className="btn btn-sm btn-outline-danger view-btn" data-id={i}><i className="fa-solid fa-eye"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            ))}

                        </ul>
                    </div>
                </section>
            )}



            <div className="lightbox-overlay" id="lightbox">
                <div className="lightbox-content" style={{ width: '115%' }}>
                    <button className="lightbox-close" id="lightbox-close">&times;</button>
                    <div className="lightbox-body">
                        <div className="lightbox-left">
                            <div id="lightboxCarousel" className="carousel slide" data-bs-ride="carousel">
                                <div className="carousel-indicators" id="carousel-indicators"></div>
                                <div className="carousel-inner" id="carousel-inner"></div>
                                <button className="carousel-control-prev" type="button" data-bs-target="#lightboxCarousel" data-bs-slide="prev"> <span className="carousel-control-prev-icon"></span> </button>
                                <button className="carousel-control-next" type="button" data-bs-target="#lightboxCarousel" data-bs-slide="next"> <span className="carousel-control-next-icon"></span> </button>
                            </div>
                        </div>
                        <div className="lightbox-data" id="lightbox-data"></div>
                    </div>
                    <div className="lightbox-footer">
                        <button id="popup-prev">&laquo; Previous</button>
                        <button id="popup-next">Next &raquo;</button>
                    </div>
                </div>
            </div>

            <div id="lightbox-items" className="d-none">
                {data.map((item, index) => {
                    // Split the comma-separated string into an array
                    const project_banner_image = item.project_banner_image
                        ? item.project_banner_image.split(",").map(s => s.trim())
                        : [];

                    return (
                        <div className="lightbox-item">
                            <div className="images">
                                {project_banner_image.map((img, i) => (
                                    <div key={i} className="service-item">
                                        <img src={`${imgPath}/${img}`} alt={img} style={{ width: 100 }} />
                                        <span>{img}</span>
                                    </div>
                                ))}
                            </div>

                            <div className="content">
                                <h4 className="datatitle">
                                    {item.ClientName}
                                    <span>
                                        <i className="material-symbols-outlined">language</i>


                                        {(item.website_url == null || item.website_url == 'null' || item.website_url == '') ?
                                            <>N/A<em className="material-symbols-outlined">arrow_outward</em></>
                                            :
                                            <Link to={item.website_url.startsWith('http://') || item.website_url.startsWith('https://')
                                                ? item.website_url
                                                : `https://${item.website_url}`} target="_blank">
                                                {item.website_url}
                                                <em className="material-symbols-outlined">arrow_outward</em>
                                            </Link>
                                        }

                                    </span>
                                </h4>

                                <ul className="nav nav-tabs proTab" id="proTab" role="tablist">
                                    <li className="nav-item" role="presentation"> <a href="#" className="nav-link active" id="project-tab" data-bs-toggle="tab" data-bs-target="#project-tab-pane" type="button" role="tab" aria-controls="project-tab-pane" aria-selected="true">Project Details</a> </li>
                                    <li className="nav-item" role="presentation"> <a href="#" className="nav-link" id="casestudy-tab" data-bs-toggle="tab" data-bs-target="#casestudy-tab-pane" type="button" role="tab" aria-controls="casestudy-tab-pane" aria-selected="false">Solutions Provided</a> </li>

                                    {(item.key_features == null || item.key_features == 'null' || item.key_features == '') ? '' :
                                        <li className="nav-item" role="presentation"> <a href="#" className="nav-link" id="keyfeature-tab" data-bs-toggle="tab" data-bs-target="#keyfeature-tab-pane" type="button" role="tab" aria-controls="keyfeature-tab-pane" aria-selected="false">Key Features</a> </li>
                                    }

                                    {(item.impact_achievements == null || item.impact_achievements == 'null' || item.impact_achievements == '') ? '' :
                                        <li className="nav-item" role="presentation"> <a href="#" className="nav-link" id="impact-tab" data-bs-toggle="tab" data-bs-target="#impact-tab-pane" type="button" role="tab" aria-controls="impact-tab-pane" aria-selected="false">Impact & Achievements</a> </li>
                                    }

                                </ul>
                                <div className="tab-content" id="proTabContent">
                                    <div className="tab-pane fade show active" id="project-tab-pane" role="tabpanel" aria-labelledby="project-tab" tabindex="0">

                                        <div className="service">
                                            <ul>
                                                <li>
                                                    <strong>Since :</strong>
                                                    <div>
                                                        <span className="material-symbols-outlined">calendar_month</span>
                                                        {item.project_since == 0 ? 'N/A' : item.project_since}
                                                    </div>
                                                </li>
                                                <li>
                                                    <strong>Business Domain :</strong>
                                                    <div>
                                                        <span className="material-symbols-outlined">account_balance</span>
                                                        {item.businessDomains}
                                                    </div>
                                                </li>
                                                <li><strong>Service Type :</strong>
                                                    {item.ServiceTypes &&
                                                        item.ServiceTypes.split(" | ").map((type, index) => (
                                                            <div key={index}>
                                                                <span className="material-symbols-outlined">
                                                                    {type.trim().toLowerCase().includes("software")
                                                                        ? "dashboard_customize"
                                                                        : type.trim().toLowerCase().includes("website")
                                                                            ? "captive_portal"
                                                                            : type.trim().toLowerCase().includes("social media")
                                                                                ? "3p"
                                                                                : type.trim().toLowerCase().includes("mobile application")
                                                                                    ? "mobile_chat"
                                                                                    : type.trim().toLowerCase().includes("digitization")
                                                                                        ? "gamepad_circle_left"
                                                                                        : type.trim().toLowerCase().includes("manpower")
                                                                                            ? "wc"
                                                                                            : type.trim().toLowerCase().includes("helpline")
                                                                                                ? "settings_phone"
                                                                                                : type.trim().toLowerCase().includes("hardware")
                                                                                                    ? "hardware"
                                                                                                    : type.trim().toLowerCase().includes("man power")
                                                                                                        ? "wc"
                                                                                                        : type.trim().toLowerCase().includes("audit certification")
                                                                                                            ? "workspace_premium"
                                                                                                            : type.trim().toLowerCase().includes("search engine optimisation (seo)")
                                                                                                                ? "search_gear"
                                                                                                                : type.trim().toLowerCase().includes("web portal")
                                                                                                                    ? "captive_portal"
                                                                                                                    : type.trim().toLowerCase().includes("solar policy")
                                                                                                                        ? "policy_alert"
                                                                                                                        : type.trim().toLowerCase().includes("bio energy portal")
                                                                                                                            ? "energy_savings_leaf"
                                                                                                                            : type.trim().toLowerCase().includes("solar energy portal")
                                                                                                                                ? "lightning_stand"
                                                                                                                                : type.trim().toLowerCase().includes("secured socket layer (ssl)")
                                                                                                                                    ? "security"
                                                                                                                                    : type.trim().toLowerCase().includes("domain name renewal & email infrastructure ")
                                                                                                                                        ? "cloud_sync"
                                                                                                                                        : "apps"}
                                                                </span>

                                                                {type.trim()}
                                                                {type.trim().toLowerCase().includes("mobile application") && (
                                                                    <>
                                                                        &nbsp;<i className="fa-brands fa-android appicon android"></i>&nbsp;
                                                                        <i className="fa-brands fa-apple appicon ios"></i>
                                                                    </>
                                                                )}

                                                            </div>
                                                        ))}
                                                </li>
                                            </ul>
                                            {(item.case_study || item.case_study_pdf) && (
                                                <div className="button service-button">
                                                    <Link to={item.case_study_pdf == null ? item.case_study : `${imgPath}/${item.case_study_pdf}`} className="ml-5 btn btn-sm btn-primary d-block" target="_blank">Case Study</Link>
                                                </div>
                                            )}
                                        </div>
                                        <h5>Project Overview</h5>
                                        {parse(item.description)}
                                    </div>

                                    <div className="tab-pane fade" id="casestudy-tab-pane" role="tabpanel" aria-labelledby="casestudy-tab" tabindex="0">
                                        {(item.solution_provided != null && item.solution_provided != 'null') ? parse(item.solution_provided, options) : <p style={{ textAlign: "center", marginTop: "50px" }}>No solution available.</p>}
                                    </div>
                                    <div className="tab-pane fade" id="keyfeature-tab-pane" role="tabpanel" aria-labelledby="keyfeature-tab" tabindex="0">
                                        {(item.key_features != null && item.key_features != 'null') ? parse(item.key_features, options) : <p style={{ textAlign: "center", marginTop: "50px" }}>No key features available.</p>}
                                    </div>
                                    <div className="tab-pane fade" id="impact-tab-pane" role="tabpanel" aria-labelledby="impact-tab" tabindex="0">
                                        {(item.impact_achievements != null && item.impact_achievements != 'null') ? parse(item.impact_achievements, options) : <p style={{ textAlign: "center", marginTop: "50px" }}>No impact achievements available.</p>}
                                    </div>

                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>


            <div className="modal fade" id="exampleModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog modal-filters">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body filters">
                            <div className="row">
                                <div className="col-md-3">
                                    <h5>Business Domain</h5>
                                    <div className="checkbox checkbox-warning">
                                        <table id="chkBusinessDomain" className="styled ">
                                            <tbody>

                                                {businessDomains.map((itm, i) => (
                                                    <tr key={`business-domain-${i}`}>
                                                        <td>
                                                            <input id={`chkBusinessDomain_${i}`} className="bussiness-domain-checkbox" type="checkbox" name={`chkBusinessDomain_${i}`} value={itm.value} />
                                                            <label for={`chkBusinessDomain_${i}`}>{itm.label}</label>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <h5>Services</h5>
                                    <div className="checkbox checkbox-warning">
                                        <table id="chkServicesType" className="styled ">
                                            <tbody>
                                                {serviceType.map((itmS, i) => (
                                                    <tr key={`service-domain-${i}`}>
                                                        <td>
                                                            <input id={`chkProjectTypeService_${i}`} className="service-type-checkbox" type="checkbox" name={`chkProjectTypeService_${i}`} value={itmS.value} />
                                                            <label for={`chkProjectTypeService_${i}`}>{itmS.label}</label>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <h5>Project</h5>
                                    <div className="checkbox checkbox-warning">
                                        <table id="chkProjectType" className="styled ">
                                            <tbody>
                                                {projectTypes.map((itmP, i) => (
                                                    <tr key={`service-project-${i}`}>
                                                        <td>
                                                            <input id={`chkProjectTypeProject_${i}`} className="project-type-checkbox" type="checkbox" name={`chkProjectTypeProject_${i}`} value={itmP.value} />
                                                            <label for={`chkProjectTypeProject_${i}`}>{itmP.label}</label>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary btn-sm getCheckedIds" data-bs-dismiss="modal">Close</button>
                            <button type="button" onClick={getCheckedIds} className="btn btn-danger btn-sm">Apply</button>
                        </div>
                    </div>
                </div>
            </div>


            <div className="modal fade" id="exampleModalLogin" tabindex="-1" aria-labelledby="exampleModalLoginLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content modal">
                        <div className="modal-header">
                            <h3 className="modal-title">Login</h3>
                            <button
                                className="close-btn"
                                aria-label="Close modal"
                                onClick={(e) => closeModal()}
                            >
                                <i className="fas fa-times"></i>
                            </button>
                        </div>

                        <div className="modal-body">
                            <form onSubmit={handleSubmit}>
                                <div className="alert alert-danger d-none d-none-remove" role="alert"></div>
                                <div className="input-group">
                                    <label htmlFor="email">Login Id</label>
                                    <div className="input-field">
                                        <input
                                            type="login_id"
                                            id="login_id"
                                            name="login_id"
                                            // onChange={handleInputChange} 
                                            placeholder="Enter your login id"
                                            className={errors.login_id ? 'error' : ''}
                                        />
                                        <i className="fas fa-envelope envelope-i"></i>
                                    </div>
                                    {errors.login_id && <span className="error-message">{errors.login_id}</span>}
                                </div>

                                <div className="input-group">
                                    <label htmlFor="password">Password</label>
                                    <div className="input-field">
                                        <input
                                            type={showPassword ? 'text' : 'password'}
                                            id="password"
                                            name="password"
                                            // onChange={handleInputChange}
                                            placeholder="Enter your password"
                                            className={errors.password ? 'error' : ''}
                                        />
                                        <button
                                            type="button"
                                            className="password-toggle"
                                            onClick={() => setShowPassword(!showPassword)}
                                            aria-label={showPassword ? 'Hide password' : 'Show password'}
                                        >
                                            <i className={`fa-eye-i fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                        </button>
                                    </div>
                                    {errors.password && <span className="error-message">{errors.password}</span>}

                                    <div className="password-options">
                                        <label className="remember-me">
                                            <input
                                                type="checkbox"
                                                name="rememberMe"
                                                checked={formData.rememberMe}
                                                onChange={handleInputChange}
                                            />
                                            Remember me
                                        </label>
                                        <button
                                            type="button"
                                            className="forgot-password"
                                            onClick={handleForgotPassword}
                                        >
                                            Forgot Password?
                                        </button>
                                    </div>
                                </div>

                                <button type="submit" className="login-btn">
                                    Login
                                </button>
                            </form>

                            {/* <div className="divider">
                                <span>Or continue with</span>
                            </div>

                            <div className="social-login">
                                <button
                                    type="button"
                                    className="social-btn google"
                                    onClick={() => handleSocialLogin('Google')}
                                >
                                    <i className="fab fa-google"></i>
                                    Google
                                </button>
                                <button
                                    type="button"
                                    className="social-btn facebook"
                                    onClick={() => handleSocialLogin('Facebook')}
                                >
                                    <i className="fab fa-facebook-f"></i>
                                    Facebook
                                </button>
                            </div>

                            <p className="register-text">
                                Don't have an account?{' '}
                                <button
                                    type="button"
                                    className="register-link"
                                    onClick={handleRegister}
                                >
                                    Register
                                </button>
                            </p>

                             */}
                        </div>
                    </div>
                </div>
            </div >



        </>
    );
}

export default Home;
